import { render, staticRenderFns } from "./PMDashboard.vue?vue&type=template&id=d7c08364&scoped=true&"
import script from "./PMDashboard.vue?vue&type=script&lang=js&"
export * from "./PMDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboard.vue?vue&type=style&index=0&id=d7c08364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c08364",
  null
  
)

export default component.exports